import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Auth.css';

export default function ResetPasswordPage() {
  const { resetPassword } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError('Reset link is missing its token. Please request a new one.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('The two passwords don\'t match.');
      return;
    }
    setSubmitting(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } catch (err) {
      setError(err?.response?.data?.detail || 'This reset link is invalid or has expired.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page" data-testid="reset-page">
      <Link to="/login" className="auth-back">&larr; Back to sign in</Link>
      <div className="auth-card">
        <img src="/seal/icraftz-wax-seal-small.png" alt="" className="auth-card-seal" aria-hidden="true" />
        <h1 className="auth-title">Choose a new <span className="auth-title-accent">Password</span></h1>
        <p className="auth-sub">Make it strong. Keep it yours.</p>
        <div className="auth-divider"><span className="auth-divider-line" /><span className="auth-divider-mark">❦</span><span className="auth-divider-line" /></div>

        {done ? (
          <p className="auth-message auth-message-success" data-testid="reset-success">
            Your password has been updated. Taking you to sign in…
          </p>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div>
              <p className="auth-field-label">New password</p>
              <input
                type="password"
                className="auth-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="reset-password"
                autoComplete="new-password"
                required
                minLength={8}
              />
            </div>
            <div>
              <p className="auth-field-label">Confirm new password</p>
              <input
                type="password"
                className="auth-input"
                placeholder="••••••••"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                data-testid="reset-confirm"
                autoComplete="new-password"
                required
                minLength={8}
              />
            </div>
            <button type="submit" className="auth-submit" disabled={submitting} data-testid="reset-submit">
              {submitting ? 'Updating…' : 'Update Password'}
            </button>
            {error && <p className="auth-message auth-message-error">{error}</p>}
          </form>
        )}
      </div>
    </div>
  );
}
